/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'underscore',
	'./SynchronizeDataModel'
], function(_, SynchronizeDataModel) {

	class SynchronizeService {
		/**
		 * The Synchronize Data service extension which manages access to the Synchronize Data API
		 * initialized with its model (as defined in the boardModelExtension).
		 */
		constructor ({ features }) {
			this.boardModel = features['internal'].getBoardModel();
			this.dashboard = features['API'];
			this.canvas = features['Canvas'];
			this.eventGroups = features['EventGroups'];

			this.synchronizeData = new SynchronizeDataModel({
				boardModel: this.boardModel,
				dashboard: this.dashboard
			});

			this.canvas.on('change:content:selections', this._handleSelectionChange, this);
		}

		destroy() {
			this.canvas.off('change:content:selections', this._handleSelectionChange, this);
		}

		getAPI() {
			return this.synchronizeData;
		}

		_getSelectionCommand(selection) {
			return selection.info.actionName === 'select' ? 'update' : 'remove';
		}

		_handleSelectionChange(event) {
			const transactionToken = event.transactionToken;
			const selections = event.info.events || [];
			selections.forEach(selection => {
				const content = this.canvas.getContent(selection.info.contentId);
				let selectionSpec;
				if (selection.info.value) {
					const utils = content.getFeature('DataPointSelections.utils');
					const cmd = this._getSelectionCommand(selection);
					selectionSpec = utils.getLegacySelection(selection.info.value, cmd, []);
				} else {
					const visualization = content.getFeature('Visualization');
					selectionSpec = {
						command: 'remove',
						edgeSelect: false,
						multiTuple: false,
						itemIds: [],
						tuple: [],
						slotsToClear: visualization.getSlots().getMappedSlotList()
					};
				}
				const controller = content.getFeature('SelectionController.deprecated');
				selectionSpec.brushingSpec = controller.getBrushingItemSpec(selectionSpec.itemIds);
				this.synchronizeData.handleBrushingSelection(selectionSpec, {
					payloadData: {
						undoRedoTransactionId: transactionToken && transactionToken.transactionId
					},
					multiTuple:  selectionSpec.multiTuple,
					synchOptions: {
						pageContext: this.boardModel.get('pageContext').getAPI(),
						newSelectionIsEmpty: (tuple) => {
							return (!tuple || !_.flatten(tuple).length);
						}
					},
					skipFilterFocus: true
				});
			});
		}
	}

	return SynchronizeService;

});
